import { z } from 'zod'

import { CurriculumTypeSchema } from '~/@entities/Curriculum'

// 강의에 붙어 오는 커리큘럼 위치. 서버는 23필드를 보내지만 앱이 읽는 것만 받는다.
// 나머지(url·hidden·sequence·*Id 들·bigChapterName·middleChapterName·littleChapterName)는
// 중단원 목록의 curriculum 이나 트리키 파싱으로 얻을 수 있어 여기서는 받지 않는다.
const _LectureCurriculumSchema = z.object({
  key: z.string(),
  type: CurriculumTypeSchema,
  id: z.number(),
  name: z.string(),
  // 서버 CurriculumResponse 는 둘 다 `String? = null` 이다. 교육과정 노드 종류에 따라 비어 온다.
  schoolName: z.string().nullable(),
  gradeName: z.string().nullable(),
  semesterName: z.string().nullable(),
  subjectName: z.string().nullable(),
})

export const LectureSchema = z.object({
  id: z.number(),
  curriculumId: z.number(),
  title: z.string(),
  thumbnailUrl: z.string(),
  videoUrl: z.string(),
  subtitleUrl: z.string().nullable(),
  orderingNumber: z.number(),
  videoLengthSeconds: z.number(),
  latestPlayedAt: z.iso.datetime({ offset: true }).nullable(),
  curriculum: _LectureCurriculumSchema,
})
export type Lecture = z.infer<typeof LectureSchema>

// 강의 묶음이 매달린 커리큘럼 노드(대단원 또는 중단원). 스펙의 CurriculumBriefResponse 와 같다.
const _CurriculumBriefSchema = z.object({
  id: z.number(),
  type: CurriculumTypeSchema,
  name: z.string(),
})

export const MiddleChapterLecturesSchema = z.object({
  curriculum: _CurriculumBriefSchema,
  lectures: z.array(LectureSchema),
})
export type MiddleChapterLectures = z.infer<typeof MiddleChapterLecturesSchema>

export const LectureGroupSchema = z.object({
  curriculum: _CurriculumBriefSchema,
  middleChapterLectures: z.array(MiddleChapterLecturesSchema),
})
export type LectureGroup = z.infer<typeof LectureGroupSchema>

export const WatchedLecturesSchema = z.object({
  lectureIds: z.array(z.number()),
})
export type WatchedLectures = z.infer<typeof WatchedLecturesSchema>
